// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__TC3Eu","layout-body":"style_layout-body__CFQy8"};